var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.$t('developers.pleaseVisitOur'))+" "),_c('a',{attrs:{"href":"https://primesurveys.com/docs/web"}},[_vm._v(_vm._s(_vm.$t('developers.sdkDocumentation')))]),_vm._v(". ")])}
var staticRenderFns = []

export { render, staticRenderFns }